import ReservationMergeIndexVue from "@/views/reservation-merge/ReservationIndex.vue";

const reservationMerge = [
  {
    path: "/reservation-merge",
    name: "reservation-merge",
    component: ReservationMergeIndexVue,
    meta: {
      layout: "default",
      role: ["superadmin","backoffice","receptionist","supervisor"],
      public: false,
    },
  },
];

export default reservationMerge;
